<template>
  <div>
    <span v-tooltip.top="formatAsDate(changedOn)">
      {{ formatRelativeToNow(changedOn) }}
    </span>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import type { YieldPromiseStatusJson } from '@/data/plants/YieldPromiseStatusJson.ts';
import {
  formatAsDate,
  formatRelativeToNow,
} from '@/infrastructure/support/utils/DateTimeUtils.ts';

export default {
  name: 'promise-period-changed-on-cell',
  props: {
    promisePeriods: {
      type: Array as PropType<YieldPromiseStatusJson[]>,
      default: () => [],
    },
  },
  methods: {
    formatRelativeToNow,
    formatAsDate(date: Date): string {
      return formatAsDate(date);
    },
  },
  computed: {
    plantId() {
      return this.promisePeriods[0].plant_id;
    },
    changedOn(): Date {
      const maxChangedOn = this.promisePeriods
        .filter((promise) => promise.last_change)
        .map((promise) => promise.last_change.changed_on)
        .reduceRight((a, b) => (a > b ? a : b), null);

      return new Date(maxChangedOn);
    },
  },
};
</script>

<style scoped></style>
